import { Navigate, useSearchParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { ForgotPasswordDocument } from '../../queries';
import { logger } from '../../utils/logging';

export function ForgotPassword() {
  const [searchParams] = useSearchParams();

  const [forgotPassword] = useMutation(ForgotPasswordDocument);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const started = useRef(false);
  const [done, setDone] = useState(false);

  const email = searchParams.get('email');
  const clientId = searchParams.get('client_id');
  const redirectUri = searchParams.get('redirect_uri');

  useEffect(() => {
    if (
      !email ||
      !clientId ||
      !redirectUri ||
      !executeRecaptcha ||
      started.current
    ) {
      return;
    }
    started.current = true;

    // grecaptcha returns a thenable without catch/finally, so await it
    const sendResetEmail = async () => {
      try {
        const captchaToken = await executeRecaptcha('forgot_password');
        await forgotPassword({
          variables: { email, clientId, redirectUri, captchaToken },
        });
      } catch (error) {
        // Always land on the check-your-email page so we don't reveal anything
        logger.error(error);
      }
      setDone(true);
    };
    sendResetEmail();
  }, [email, clientId, redirectUri, executeRecaptcha, forgotPassword]);

  if (!done) {
    return null;
  }

  return (
    <Navigate
      to={`/verify-email?${searchParams.toString()}`}
      state={{ from: 'forgot' }}
    />
  );
}
